import React from "react";

import NewInput from "../../../../../shared/forms/NewInput";
import { SalutationSelect } from "../../../../../shared/forms/NewSelect";
import NewHeadline from "../../../../../shared/NewHeadline";
import useStepDeliveryAddress from "../store";

const ContactData = () => {
    const [
        deliveryAddress,
        setDeliveryAddress,
        addError,
        clearError,
        hasErrorAt,
    ] = useStepDeliveryAddress((state) => [
        state.deliveryAddress,
        state.setDeliveryAddress,
        state.addError,
        state.clearError,
        state.hasErrorAt,
    ]);

    /**
     * On change of a value.
     *
     * @param {*} event
     */
    const handleChange = (event) => {
        setDeliveryAddress({
            ...deliveryAddress,
            ...{ [event.target.name]: event.target.value },
        });
    };

    return (
        <React.Fragment>
            <NewHeadline>Kontaktdaten</NewHeadline>

            <SalutationSelect
                name="salutation"
                onChange={handleChange}
                value={deliveryAddress.salutation}
                withField
            />

            <NewInput
                placeholder="Vorname"
                name="firstname"
                onChange={handleChange}
                value={deliveryAddress.firstname}
                validation="name"
                forceError={hasErrorAt("deliveryAddress.firstname")}
                onError={() => addError("deliveryAddress.firstname")}
                onErrorSolved={() => clearError("deliveryAddress.firstname")}
                withField
            />
            <NewInput
                placeholder="Nachname"
                name="lastname"
                onChange={handleChange}
                value={deliveryAddress.lastname}
                validation="name"
                forceError={hasErrorAt("deliveryAddress.lastname")}
                onError={() => addError("deliveryAddress.lastname")}
                onErrorSolved={() => clearError("deliveryAddress.lastname")}
                withField
            />
            <NewInput
                placeholder="E-Mail"
                name="email"
                onChange={handleChange}
                value={deliveryAddress.email}
                validation="email"
                forceError={hasErrorAt("deliveryAddress.email")}
                onError={() => addError("deliveryAddress.email")}
                onErrorSolved={() => clearError("deliveryAddress.email")}
                withField
            />
            <NewInput
                placeholder="Telefonnummer"
                name="phone"
                onChange={handleChange}
                value={deliveryAddress.phone}
                validation="phone"
                forceError={hasErrorAt("deliveryAddress.phone")}
                onError={() => addError("deliveryAddress.phone")}
                onErrorSolved={() => clearError("deliveryAddress.phone")}
                withField
            />
        </React.Fragment>
    );
};

export default ContactData;
